import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import useMediaQuery from "@mui/material/useMediaQuery";

const ColorThemeContext = createContext(undefined);

export const ThemeModeProvider = ({ children }) => {
  const systemPrefersDark = useMediaQuery(
    "(prefers-color-scheme: dark)",
    { noSsr: true }
  );

  const mode = systemPrefersDark ? "dark" : "light";

  return (
    <ColorThemeContext.Provider value={{ mode }}>
      {children}
    </ColorThemeContext.Provider>
  );
};

ThemeModeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useThemeMode = () => {
  const context = useContext(ColorThemeContext);

  if (!context) {
    throw new Error("useThemeMode must be used within ThemeModeProvider");
  }

  return context;
};